import React, { useState, useMemo } from "react";
import { useMutation } from "react-query";
import Notiflix from "notiflix";
import { Button, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import ApiRequest from "../../actions/ApiRequest";

import PageTitle from "../common/PageTitle";
import BillLogo from "./shared/BillLogo";
import { coolNet } from "assests/images/bundles/paltel/paltelImage";

import {
  getCoolnetBillsApiCalled,
  payCoolnetBillApiCalled,
} from "shared/endPoints/apiCallers";
import translate from "i18n/translate";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import EditableTextFieldForm from "./shared/InputBills";
import { calcTotalAmount } from "./shared/calcTotalAmount";
import GeneralPayModal from "./shared/GeneralPayModal";
import DataTable from "./shared/DataTable";

const CoolnetBills = () => {
  const [number, setNumber] = useState("");
  const [identity, setIdentity] = useState("");
  const [selectedBill, setSelectedBill] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [bills, setBills] = useState([]);

  const history = useHistory();

  useEffect(() => {
    const { state } = history.location;
    if (state?.number) {
      setNumber(state.number);
      setIdentity(state.identity);
      getCoolnetBills({ id: state.identity, number: state.number });
    }
  }, []);

  const {
    isLoading,
    mutate: getCoolnetBills,
    data: CoolnetPills,
    reset,
  } = useMutation(getCoolnetBillsApiCalled, {
    onSuccess: (res) => {
      if (res?.status === "failed") {
        const errorReason = res?.reason ?? "Something went wrong";
        setErrorMessage(errorReason);
        return;
      }
      ApiRequest.post(
        `/restore_ab_company?company=coolnet&session_id=${res[0].session_id}`
      );
    },
    onError: () => {
      Notiflix.Notify.failure(`Something went wrong !`, "", "Close");
    },
  });

  useEffect(() => {
    if (CoolnetPills?.length > 0) {
      setBills(CoolnetPills);
    }
  }, [CoolnetPills]);

  const onSubmit = async (value) => {
    setNumber(value);
    setSelectedBill(null);
    setBills([]);
    getCoolnetBills({ id: identity, number: value });
  };

  const clearSelections = () => {
    setSelectedBill(null);
    reset();
  };

  const totalAmount = parseFloat(calcTotalAmount(selectedBill)?.toFixed(2));

  return (
    <div>
      <PageTitle title={translate("Coolnet Bills")} backPage="/pay_bills">
        <BillLogo src={coolNet} alt="coolNet" style={{ marginTop: 20 }} />
        <EditableTextFieldForm
          initialValue={number}
          label={translate("paltel_number")}
          onSubmit={onSubmit}
          isLoading={isLoading}
        />
        {bills?.length > 0 && (
          <>
            <div className="d-flex align-items-center justify-content-between mt-4">
              <p>
                {translate("Total Bills Amount")}:{" "}
                <span className="text-info">
                  {totalAmount} {translate("ILS")}
                </span>
              </p>
              <GeneralPayModal
                selectedBill={selectedBill}
                number={number}
                isDisabled={!totalAmount || isLoading}
                clearSelections={clearSelections}
                totalAmount={totalAmount}
                apiCall={payCoolnetBillApiCalled}
              />
            </div>
            <DataTable
              rows={CoolnetPills}
              isLoading={isLoading}
              onRowSelect={setSelectedBill}
              selectedRows={selectedBill}
            />
          </>
        )}
        {CoolnetPills?.length === 0 && <h5>{translate("No Results Found")}</h5>}
        {errorMessage && <h5 className="text-danger">{errorMessage}</h5>}
        
        <Box sx={{ display: 'flex', marginTop: 4, marginBottom: 2 }}>
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/pay_bills")}
            sx={{ minWidth: 120 }}
          >
            {translate("Back")}
          </Button>
        </Box>
      </PageTitle>
    </div>
  );
};

export default CoolnetBills;
